var _rect, _path, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPromptBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#00AEB9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9986 20C30.9198 20 30.0428 20.8746 30.0428 21.9534L30.0429 21.9734C26.5434 22.5535 23.875 25.5943 23.875 29.2582V38.0995H23.8735C23.0589 38.0995 22.3984 38.76 22.3984 39.5746C22.3984 40.3893 23.0589 41.0497 23.8735 41.0497H29.7812V41.7842C29.7812 43.0077 30.7731 43.9996 31.9966 43.9996C33.2202 43.9996 34.212 43.0077 34.212 41.7842V41.0497H40.1233C40.938 41.0497 41.5984 40.3893 41.5984 39.5746C41.5984 38.76 40.938 38.0995 40.1233 38.0995H40.1212V29.2582C40.1212 25.5946 37.4533 22.5542 33.9543 21.9736L33.9544 21.9534C33.9544 20.8746 33.0775 20 31.9986 20Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 7.5,
    y: 7.5,
    width: 49,
    height: 49,
    rx: 24.5,
    stroke: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 4.5,
    y: 4.5,
    width: 55,
    height: 55,
    rx: 27.5,
    stroke: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 10.5,
    y: 10.5,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromptBell);
export default __webpack_public_path__ + "static/media/promptBell.549b3c68e0bdd51ab8f642a22ad9c884.svg";
export { ForwardRef as ReactComponent };